import React from "react";
import "./popup.css";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  heading?: string;
  paragraph?: string;
  onSubmit?: () => void;
}

const Popup: React.FC<PopupProps> = ({ isOpen, onClose, heading, paragraph, onSubmit }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        <h2 className="heading">{heading}</h2>
        <p className="paragraph">{paragraph}</p>
        {onSubmit && (
          <button className="pop-up-submit-button" onClick={onSubmit}>
            Submit Ticket
          </button>
        )}
        <div className="close-button">
          <button className="pop-up-close-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
